import * as Sentry from '@sentry/react';

const logError = <E extends Error>(e: E) => {
    if (import.meta.env.PROD) {
        return Sentry.captureException(e);
    }

    // eslint-disable-next-line no-console
    return console.error(e);
};

export { logError };
